
<template>
  <div class="center">

  <el-row>
  <el-col :span="12">
    <el-card :body-style="{ padding: '0px' }">
      <img :src="qrcodeUrl" class="image">
      <div style="padding: 14px;">
        <span>{{nickName}}</span>
        <span>{{principalName}}</span>
        <div class="bottom clearfix">
          <span style="color:red">授权完毕，请关闭该窗口！</span>
        </div>
      </div>
    </el-card>
  </el-col>
</el-row>

</div>

</template>

<script>
import sysModel from '../../framework/models/sysModel'
export default {
  name: 'wechart-success',
  data: function () {
    return {
      channelId: null,
      authCode: null,
      expiresIn: null,
      nickName: null,
      principalName: null,
      qrcodeUrl: null,
      headImg: null

    }
  },
  created: function () {
    let params = this.$route.params
    let that = this
    that.channelId = params.channelId

    that.getPublicAccountInfo()
  },
  methods: {
    getPublicAccountInfo: function () {
      let that = this
      let param = {
        channelId: that.channelId
      }
      let listener = {
        success: function (datas) {
          if (datas.success) {
            console.log(datas.datas)
            let data = datas.datas
            that.headImg = data.head_img
            that.qrcodeUrl = data.qrcode_url
            that.principalName = data.principal_name
            that.nickName = data.nick_name
          }
        },
        error: function (datas) {

        }
      }
      sysModel.getPublicAccountInfo(that, param, listener)
    }

  }
}
</script>
<style>
.image {
  width: 100%;
  display: block;
}

.center {
    margin: auto;
    width: 100%;
    border: 3px solid 0;
    padding: 10px;
    text-align: center;
}

</style>
